// extracted by mini-css-extract-plugin
export default {"DrawerHeaderLayout":"DrawerHeaderLayout_DrawerHeaderLayout__Qx0Wl","BackArrow":"DrawerHeaderLayout_BackArrow__MuAmn"};